module.exports = __webpack_public_path__ + "static/media/ivs-logo.5ff5836b.png";